import React from 'react'

import { Header } from '../../components/Header'
import { AddReview } from '../../components/AddReview'
import { MessageSitter } from '../../components/MessageSitter'
import { Reviews } from '../../components/Reviews'
import { Footer } from '../../components/Footer'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export const SitterDetail = () => {
    var settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1
    };

    return (
        <>
            <Header />
            <Slider  {...settings}>
                <div className="slick-slide" >
                    <a href="./images/single-listing-05a.jpg" className="item mfp-gallery" title="Title 1">
                        <img src="./images/single-listing-05a.jpg" />
                    </a>
                </div>
                <div className="slick-slide" >
                    <a href="images/single-listing-05b.jpg" className="item mfp-gallery" title="Title 3">
                        <img src="./images/single-listing-05b.jpg" />
                    </a>
                </div>
                <div className="slick-slide" >
                    <a href="images/single-listing-05c.jpg" className="item mfp-gallery" title="Title 2">
                        <img src="./images/single-listing-05c.jpg" />
                    </a>
                </div>
                <div className="slick-slide" >
                    <a href="images/single-listing-05d.jpg" className="item mfp-gallery" title="Title 4">
                        <img src="./images/single-listing-05d.jpg" />
                    </a>
                </div>
                <div className="slick-slide" >
                    <a href="./images/single-listing-05a.jpg" className="item mfp-gallery" title="Title 1">
                        <img src="./images/single-listing-05a.jpg" />
                    </a>
                </div>
                <div className="slick-slide" >
                    <a href="images/single-listing-05b.jpg" className="item mfp-gallery" title="Title 3">
                        <img src="./images/single-listing-05b.jpg" />
                    </a>
                </div>
                <div className="slick-slide" >
                    <a href="images/single-listing-05c.jpg" className="item mfp-gallery" title="Title 2">
                        <img src="./images/single-listing-05c.jpg" />
                    </a>
                </div>
                <div className="slick-slide" >
                    <a href="images/single-listing-05d.jpg" className="item mfp-gallery" title="Title 4">
                        <img src="./images/single-listing-05d.jpg" />
                    </a>
                </div>
            </Slider>
            <div className="container">
                <div className="row sticky-wrapper">
                    <div className="col-lg-8 col-md-8 padding-right-30">

                        {/* <!-- Titlebar --> */}
                        <div id="titlebar" className="listing-titlebar">
                            <div className="listing-titlebar-title">
                                <h2>Joe's Photography Inc. <span className="listing-tag">Services</span></h2>
                                <span>
                                    <a href="#listing-location" className="listing-address">
                                        <i className="fa fa-map-marker"></i>
							2726 Shinn Street, New York
						</a>
                                </span>
                                <div className="star-rating" data-rating="5">
                                    <div className="rating-counter"><a href="#listing-reviews">(12 reviews)</a></div>
                                </div>
                            </div>
                        </div>

                        {/* <!-- Listing Nav --> */}
                        <div id="listing-nav" className="listing-nav-container">
                            <ul className="listing-nav">
                                <li><a href="#listing-overview" className="active">Overview</a></li>
                                <li><a href="#listing-pricing-list">Pricing</a></li>
                                <li><a href="#listing-location">Location</a></li>
                                <li><a href="#listing-reviews">Reviews</a></li>
                                <li><a href="#add-review">Add Review</a></li>
                            </ul>
                        </div>

                        {/* <!-- Overview --> */}
                        <div id="listing-overview" className="listing-section">

                            {/* <!-- Description --> */}

                            <p>
                                Ut euismod ultricies sollicitudin. Curabitur sed dapibus nulla. Nulla eget iaculis lectus. Mauris ac maximus neque. Nam in mauris quis libero sodales eleifend. Morbi varius, nulla sit amet rutrum elementum, est elit finibus tellus, ut tristique elit risus at metus.
				</p>

                            <p>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas in pulvinar neque. Nulla finibus lobortis pulvinar. Donec a consectetur nulla. Nulla posuere sapien vitae lectus suscipit, et pulvinar nisi tincidunt. Aliquam erat volutpat. Curabitur convallis fringilla diam sed aliquam. Sed tempor iaculis massa faucibus feugiat. In fermentum facilisis massa, a consequat purus viverra.
				</p>


                            {/* <!-- Listing Contacts --> */}
                            <div className="listing-links-container">

                                <ul className="listing-links contact-links">
                                    <li><a href="tel:12-345-678" className="listing-links"><i className="fa fa-phone"></i> +12 345 6578</a></li>
                                    <li><a href="mailto:mail@example.com" className="listing-links"><i className="fa fa-envelope-o"></i> mail@example.com</a>
                                    </li>
                                    <li><a href="#" target="_blank" className="listing-links"><i className="fa fa-link"></i> www.example.com</a></li>
                                </ul>
                                <div className="clearfix"></div>

                                <ul className="listing-links">
                                    <li><a href="#" target="_blank" className="listing-links-fb"><i className="fa fa-facebook-square"></i> Facebook</a></li>
                                    <li><a href="#" target="_blank" className="listing-links-yt"><i className="fa fa-youtube-play"></i> YouTube</a></li>
                                    <li><a href="#" target="_blank" className="listing-links-ig"><i className="fa fa-instagram"></i> Instagram</a></li>
                                    <li><a href="#" target="_blank" className="listing-links-tt"><i className="fa fa-twitter"></i> Twitter</a></li>
                                </ul>
                                <div className="clearfix"></div>

                            </div>
                            <div className="clearfix"></div>


                            {/* <!-- Amenities --> */}
                            <h3 className="listing-desc-headline">Amenities</h3>
                            <ul className="listing-features checkboxes margin-top-0">
                                <li>Elevator in building</li>
                                <li>Friendly workspace</li>
                                <li>Instant Book</li>
                                <li>Wireless Internet</li>
                                <li>Free parking on premises</li>
                                <li>Free parking on street</li>
                            </ul>
                        </div>


                        {/* <!-- Food Menu --> */}
                        <div id="listing-pricing-list" className="listing-section">
                            <h3 className="listing-desc-headline margin-top-70 margin-bottom-30">Pricing</h3>

                            <div className="pricing-list-container">

                                {/* <!-- Food List --> */}
                                <h4>Wedding Photography</h4>
                                <ul>
                                    <li>
                                        <h5>Basic</h5>
                                        <p>up to 3 hours of coverage, 1 photographers, photo book</p>
                                        <span>$1000</span>
                                    </li>
                                    <li>
                                        <h5>Classic</h5>
                                        <p>up to 5 hours of coverage, 1 photographer, photo book</p>
                                        <span>$1500</span>
                                    </li>
                                    <li>
                                        <h5>Standard</h5>
                                        <p>up to 8 hours of coverage, 2 photographers, photo book, engagement session, 16x20 canvas print of your choice</p>
                                        <span>$2000</span>
                                    </li>
                                    <li>
                                        <h5>Premium</h5>
                                        <p>up to 10 hours of coverage, 2 photographers, photo book, engagement session, 16x20 canvas print of your choice</p>
                                        <span>$2500</span>
                                    </li>
                                </ul>

                            </div>

                        </div>
                        {/* <!-- Food Menu / End -->

		TODO: AVERIGUAR LA OPCION DE PONER EL OPEN STREET MAP
			<!-- Location --> */}
                        {/* <div id="listing-location" className="listing-section">
                            <h3 className="listing-desc-headline margin-top-60 margin-bottom-30">Location</h3>

                            <div id="singleListingMap-container">
                                <div id="singleListingMap" data-latitude="40.70437865245596" data-longitude="-73.98674011230469" data-map-icon="im im-icon-Hamburger"></div>
                                <a href="#" id="streetView">Street View</a>
                            </div>
                        </div> */}


                        <Reviews />
                        <AddReview />



                    </div>


                    {/* <!-- Sidebar=== --> */}
                    <div className="col-lg-4 col-md-4 margin-top-75 sticky">


                        {/* <!-- Verified Badge --> */}
                        <div className="verified-badge with-tip" data-tip-content="Listing has been verified and belongs the business owner or manager.">
                            <i className="sl sl-icon-check"></i> Verified Listing
			            </div>
                        <MessageSitter />

                        {/* <!-- Book Now / End -->
			            <!-- Opening Hours --> */}
                        <div className="boxed-widget opening-hours margin-top-35">
                            <div className="listing-badge now-open">Now Open</div>
                            <h3><i className="sl sl-icon-clock"></i> Opening Hours</h3>
                            <ul>
                                <li>Monday <span>9 AM - 5 PM</span></li>
                                <li>Tuesday <span>9 AM - 5 PM</span></li>
                                <li>Wednesday <span>9 AM - 5 PM</span></li>
                                <li>Thursday <span>9 AM - 5 PM</span></li>
                                <li>Friday <span>9 AM - 5 PM</span></li>
                                <li>Saturday <span>9 AM - 3 PM</span></li>
                                <li>Sunday <span>Closed</span></li>
                            </ul>
                        </div>
                        {/* <!-- Opening Hours / End -->


            			<!-- Contact --> */}
                        <div className="boxed-widget margin-top-35">
                            <div className="hosted-by-title">
                                <h4><span>Hosted by</span> <a href="pages-user-profile.html">Tom Perrin</a></h4>
                                <a href="pages-user-profile.html" className="hosted-by-avatar"><img src="images/dashboard-avatar.jpg" alt="" /></a>
                            </div>
                            <ul className="listing-details-sidebar">
                                <li><i className="sl sl-icon-phone"></i> (123) 123-456</li>
                                <li><i className="fa fa-envelope-o"></i> <a href="#">tom@example.com</a></li>
                            </ul>

                            <ul className="listing-details-sidebar social-profiles">
                                <li><a href="#" className="facebook-profile"><i className="fa fa-facebook-square"></i> Facebook</a></li>
                                <li><a href="#" className="twitter-profile"><i className="fa fa-twitter"></i> Twitter</a></li>
                            </ul>

                            {/* <!-- Reply to review popup --> */}
                            <div id="small-dialog" className="zoom-anim-dialog mfp-hide">
                                <div className="small-dialog-header">
                                    <h3>Send Message</h3>
                                </div>
                                <div className="message-reply margin-top-0">
                                    <textarea cols="40" rows="3" placeholder="Your message to Tom"></textarea>
                                    <button className="button">Send Message</button>
                                </div>
                            </div>

                            <a href="#small-dialog" className="send-message-to-owner button popup-with-zoom-anim"><i className="sl sl-icon-envelope-open"></i> Send Message</a>
                        </div>
                        {/* <!-- Contact / End--> */}


                        {/* <!-- Share / Like --> */}
                        <div className="listing-share margin-top-40 margin-bottom-40 no-border">
                            <button className="like-button"><span className="like-icon"></span> Bookmark this listing</button>
                            <span>159 people bookmarked this place</span>

                            {/* <!-- Share Buttons --> */}
                            <ul className="share-buttons margin-top-40 margin-bottom-0">
                                <li><a className="fb-share" href="#"><i className="fa fa-facebook"></i> Share</a></li>
                                <li><a className="twitter-share" href="#"><i className="fa fa-twitter"></i> Tweet</a></li>
                                <li><a className="gplus-share" href="#"><i className="fa fa-google-plus"></i> Share</a></li>
                            </ul>
                            <div className="clearfix"></div>
                        </div>

                    </div>
                    {/* <!-- Sidebar / End --> */}

                </div>
            </div>
            <Footer />
        </>
    )
}